import {
  SET_MEDIATION_REQUEST_PAGE_DATA,
  MEDIATION_REQUEST_PAGE_LOADER,
  MEDIATION_REQUEST_LOADER,
  SET_MEDIATION_REQUEST,
} from "../actionTypes";

const initialState = {
  loader: false,
  mediationForm: {},
  mediationRequest: {},
};

const mediationRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case MEDIATION_REQUEST_PAGE_LOADER:
      return {
        ...state,
        loader: action.payload,
      };
    case SET_MEDIATION_REQUEST_PAGE_DATA: {
      return {
        ...state,
        mediationForm: action.payload,
      };
    }
    case MEDIATION_REQUEST_LOADER:
      return {
        ...state,
        loader: action.payload,
      };
    case SET_MEDIATION_REQUEST: {
      return {
        ...state,
        mediationRequest: action.payload,
      };
    }
    default:
      return state;
  }
};

export default mediationRequestReducer;
